import { useState } from "react";
import ProjectReportPage from "../ProjectReportPage";
import WelcomeGuideModal, { isGuideSeen } from "../../components/new/WelcomeGuideModal";
import { useTutorial } from "../../context/TutorialContext";

export default function ReportPage() {
  const { run, pendingStartRef } = useTutorial();
  const [isOpenGuide, setIsOpenGuide] = useState(() => !isGuideSeen("report") && !run && !pendingStartRef.current);

  return (
    <>
      <WelcomeGuideModal type="report" open={isOpenGuide} onClose={() => setIsOpenGuide(false)} />
      <ProjectReportPage />
    </>
  );
}
